<wms-dialog-header [title]="locale.LABEL_COPILOT" (onClose)="onModalClose()">
</wms-dialog-header>
<wms-dialog-body>
  <div class="copilot-prompt-container" *ngIf="copilotService.currentScreen === 'prompt-screen'">
    <div class="copilot-prompt-input-wrapper">
      <input id="copilot-prompt" class="prompt-input" placeholder={{locale.LABEL_COPILOT_HELP_MSG}}
        [(ngModel)]="promptText" autocomplete="off" />
      <button class="copilot-generate-btn" (click)="enableDataConfigurationStep()"
        [disabled]="!promptText || !isValidWidgetType"
        [title]="isValidWidgetType ? locale.LABEL_COPILOT_GENERATE: locale.LABEL_NO_COPILOT_SUPPORT">
        <img [src]="(copilotIconSrc | versionManager)" alt="Copilot Icon"
          class="copilot-icon" />
        <span>{{locale['LABEL_COPILOT_GENERATE']}}</span>
      </button>
    </div>
    <div class="prompt-suggestions">
      <button *ngFor="let suggestion of prompts" class="copilot-suggestion-btn" (click)="handleSuggestionClick(suggestion)">
        <img [src]="(copilotIconSrc | versionManager)" alt="Copilot Icon"
          class="copilot-icon" />
        <span>{{suggestion}}</span>
      </button>
    </div>
  </div>
  <div class="copilot-data-config" *ngIf="copilotService.currentScreen === 'data-configuration'">
    <div>
      <label class="form-label">{{locale.LABEL_CHOOSE_DATASOURCE}}</label>
      <wms-typeahead name="wms-source-data-source" placeholder="{{locale.MESSAGE_PLACEHOLDER_SELECT_DATA_SOURCE}}"
        [model]="serviceId" [options]="dataSource" (onSelect)="onServiceSelect($event)" [typeaheadUid]="'dataSource'"
        (onClear)="clearSource()" propertyName="name" [dropdownClass]="'copilot'"></wms-typeahead>
    </div>
    <div>
      <label class="form-label">{{locale.LABEL_CHOOSE_OPERATION}}</label>
      <wms-typeahead name="wms-source-data-operation" [typeaheadUid]="'dataOperation'" [dropdownClass]="'copilot'"
        placeholder="{{locale.MESSAGE_PLACEHOLDER_SELECT}} {{locale.LABEL_SELECT_OPERATION_TYPE}}"
        [model]="operationName" [options]="operations" (onClear)="clearOperation()"
        (onSelect)="onOperationSelect($event)" propertyName="name" groupBy="type"></wms-typeahead>
    </div>
    <button class="copilot-generate-btn" (click)="generateSuggestions()" [disabled]="!serviceId || !operationId"
      [title]="locale.LABEL_COPILOT_GENERATE">
      <img [src]="(copilotIconSrc | versionManager)" alt="Copilot Icon"
        class="copilot-icon" />
      <span>{{locale['LABEL_COPILOT_GENERATE']}}</span>
    </button>
  </div>
  <div class="copilot-results" *ngIf="copilotService.currentScreen === 'results-screen'">
    <div class="copilot-results-body">
      <img [src]="'assets/images/copilot/copilot-success.png' | versionManager" alt="Generated Results" />
      <p class="copilot-results-title">{{locale.LABEL_COPILOT_GENERATION_SUCCESS}}</p>
      <p class="copilot-results-message">{{locale.LABEL_COPILOT_RESULT_MSG}}</p>
    </div>
    <div class="copilot-results-actions">
      <i class="wi wi-keyboard-arrow-left" (click)="navigateBackward()" *ngIf="currentIndex !==0"></i>
      <button class="copilot-discard-btn" (click)="onModalClose()">{{locale.LABEL_DISCARD}}</button>
      <button class="copilot-generate-btn" (click)="saveSuggestion()">{{locale.LABEL_ADD_TO_PROJECT}}</button>
      <i class="wi wi-keyboard-arrow-right" (click)="navigateForward()"
        *ngIf="currentIndex !== markupContent.length-1"></i>
    </div>
  </div>
</wms-dialog-body>